// Verbatim from docs/Code I_O HTML Problems.pdf — Challenge 1.
export const BROKEN_ANIMAL_HTML = `<h1>Cool Animal Facts<h1>

<p>Here are some fun facts about animals!</p>

<ul>
  <li>Octopuses have three hearts.</li>
  <li>A group of flamingos is called a flamboyance.<li>
  <li>Sloths can hold their breath longer than dolphins.</li>
</ul>

<th>Animal</th>
<th>Top Speed</th>
</tr>

<tr>
  <td>Cheetah</td>
  <td>75 mph<td>
</tr>

<tr>
  <td>Horse</td>
  <td>55 mph</td>
</tr>

</table>

</body>
<html>

<h2>Animal Speed Table</h2>

<table>
  <tr>
`;
